"use client";

import { usePathname, useRouter } from "next/navigation";

/**
 * Floating top-right control — same fixed viewport behavior as Report a bug
 * (bottom-right). Stays on screen while the page scrolls.
 */
export function GoBackButton() {
  const router = useRouter();
  const pathname = usePathname();

  // No back on the main entry / logo home
  if (!pathname || pathname === "/") return null;

  function goBack() {
    if (typeof window !== "undefined" && window.history.length > 1) {
      router.back();
      return;
    }
    router.push("/home/general");
  }

  return (
    <div className="go-back-float" role="navigation" aria-label="Go back">
      <button
        type="button"
        onClick={goBack}
        className="btn-ghost text-sm"
        aria-label="Go back"
      >
        ← Back
      </button>
    </div>
  );
}
